// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import Text from "@cloudspire/legacy-resources/src/components/Text2";
import { EstimatePrice } from "@cloudspire/legacy-resources/src/components/Estimate";

type PropsType = {
  mode: "responsive" | "plain";
  type: "booking" | "room" | "payment";
  priceToRender: "booking" | "pricing";
  hasBookingEstimatePrice: boolean;
  hasPricingEstimatePrice: boolean;
  bookingEstimatePrice;
  pricingEstimatePrice;
};

const BookingAsidePrice: React.FunctionComponent<PropsType> = (props) => {
  const {
    type,
    mode,
    priceToRender,
    hasBookingEstimatePrice,
    hasPricingEstimatePrice,
    bookingEstimatePrice,
    pricingEstimatePrice,
  } = props;

  const intl = useIntl();

  return (
    <>
      {"payment" !== type && (
        <>
          {(priceToRender === "booking"
            ? !isNaN(parseFloat(bookingEstimatePrice))
            : !isNaN(parseFloat(pricingEstimatePrice))) &&
            "plain" === mode && <Stack marginTop={1} />}

          {"booking" === priceToRender && (
            <div>
              {hasBookingEstimatePrice && (
                <EstimatePrice
                  price={bookingEstimatePrice}
                  priceToRender={priceToRender}
                  size="sm"
                />
              )}
            </div>
          )}

          {"pricing" === priceToRender && (
            <>
              {hasPricingEstimatePrice ? (
                <div>
                  <EstimatePrice
                    price={pricingEstimatePrice}
                    priceToRender={priceToRender}
                    size="sm"
                  />

                  {"room" === type && (
                    <>
                      <Stack marginTop={0.5} />

                      <Text style={{ fontSize: "0.75rem" }}>
                        {intl.formatMessage({
                          defaultMessage:
                            "Tarif estimé hors services et frais supplémentaires",
                        })}
                      </Text>
                    </>
                  )}
                </div>
              ) : (
                <div>
                  <Text style={{ fontWeight: "700" }}>
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          "Planning en cours de mise à jour. Nous vous invitons à nous contacter en cliquant sur un des liens {mode, select, responsive {en cliquant sur la flèche de gauche} other {ci-dessous}}.",
                      },
                      {
                        mode,
                      }
                    )}
                  </Text>
                </div>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default BookingAsidePrice;
